// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".booking-fail .el-dialog__body {\n  padding: 0 !important;\n}\n.booking-fail .booking-fail-body span {\n  font-size: 18px;\n}\n", ""]);
// Exports
module.exports = exports;
